// BotaoVerMais.js — o "mostrar mais / mostrar menos" de toda a página do livro.
//
// ================= POR QUE A PÁGINA PASSOU A RECOLHER (17/09/2026) =================
//
// No celular a página do livro tinha 8.162px de altura — perto de dez telas
// cheias. O dono pediu para ela "não ficar com muita informação" e sugeriu o
// "Ler mais". O print a 390px mostrou onde estava o excesso: a ficha técnica em
// oito caixas empilhadas, os relacionados em três fileiras de cartões, os passos
// da compra (iguais em todo livro) e a sinopse inteira aberta.
//
// A REGRA DO RECOLHIMENTO é a mesma em todas essas seções, e por isso o botão
// é um só:
//
//   - NADA SOME DE VEZ. Tudo o que está recolhido está a um toque, e o botão
//     diz QUANTO está escondido ("+4"), para ninguém abrir à toa.
//   - RECOLHE SÓ ONDE PRECISA. No computador a maioria dessas seções cabe
//     inteira; quem decide é a seção, com a classe `sm:hidden` no botão.
//   - O BOTÃO É LARGO. Um link de 14px no pé de uma seção é um alvo de toque
//     ruim no celular, que é justamente onde ele aparece.
import React from "react";

export default function BotaoVerMais({
  aberto,
  aoAlternar,
  textoFechado,
  textoAberto = "Mostrar menos",
  // A margem de cima é SUBSTITUÍVEL, e não sobreposta por `className`: `mt-3` é
  // homônimo do Bootstrap (!important), e entre dois !important quem decide é
  // a ordem das folhas, não a da classe. Quem precisa de outra margem troca
  // esta prop inteira.
  margem = "mt-[0.75rem]",
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={aoAlternar}
      aria-expanded={aberto}
      className={
        "foco-laranja " + margem + " flex w-full items-center justify-center gap-2 rounded-controle border-2 " +
        "border-insigne-sombra bg-insigne-navy-soft py-2.5 text-sm font-semibold text-white/85 " +
        "transition-colors hover:border-insigne-orange/60 hover:text-insigne-orange " +
        className
      }
    >
      {aberto ? textoAberto : textoFechado}
      <i className={"bi text-xs " + (aberto ? "bi-chevron-up" : "bi-chevron-down")} aria-hidden="true" />
    </button>
  );
}
